import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = (props: { genreTab: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      mediaCenterContainer: {
        display: 'grid',
        [theme.breakpoints.down('sm')]: {
          display: 'none'
        }
      },
      headerContainer: {
        alignItems: 'center',
        display: 'flex',
        height: '100px',
        padding: '24px 0'
      },
      mediaCenterHeaderText: {
        fontSize: '40px',
        fontWeight: 600,
        lineHeight: '1',
        [theme.breakpoints.only('xs')]: {
          fontSize: '32px'
        }
      },
      mediaCenterNotAvailable: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0px 10px'
        },
        [theme.breakpoints.only('sm')]: {
          padding: '0px 30px',
          height: 'calc(100vh - 104px)'
        },
        [theme.breakpoints.only('xs')]: {
          height: 'calc(100vh - 89px)'
        }
      },
      mediaNotAvailableMessage: {
        fontSize: '32px',
        lineHeight: '1.13',
        textAlign: 'center',
        [theme.breakpoints.only('xs')]: {
          fontSize: '24px'
        }
      },
      mediaCenterSelectorPills: {
        '& > * > button': {
          [theme.breakpoints.only('md')]: {
            width: props.genreTab ? '125px' : '169px'
          }
        }
      },
      tableDetailsOuterBox: {
        flex: 'none',
        background: 'transparent'
      },
      tableContainer: {
        height: '400px',
        [theme.breakpoints.down('sm')]: {
          height: '570px'
        }
      },
      singleRowTableContainer: {
        height: '121px'
      },
      tableRow: {
        display: 'flex'
      },
      tableHeadCell: {
        fontWeight: 600,
        lineHeight: '1.13',
        whiteSpace: 'nowrap'
      },
      tableCell: {
        alignContent: 'center',
        fontSize: '16px',
        padding: '16px',
        '&:first-child': {
          paddingLeft: '24px'
        },
        '&:last-child': {
          paddingRight: '24px'
        }
      },
      tableLabelCell: {
        flex: '1 1 30%'
      },
      tableFileNameCell: {
        flex: '1 1 30%'
      },
      tableDimensionsCell: {
        flex: '1 1 20%'
      },
      tableActionsCell: {
        flex: '0 0 214px',
        textAlign: 'center'
      },
      linkedContentTableActionsCell: {
        flex: '0 0 122px',
        textAlign: 'center'
      },
      actionIconBox: {
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        borderRadius: '50%',
        border: `2px solid black`
      },
      actionSvgIconBox: {
        cursor: 'pointer',
        alignItems: 'center'
      },
      overlayFieldBox: {
        height: '110px',
        minHeight: '110px',
        width: '100%'
      }
    })
  );
